<template>
    <div>
        <h3 class="kgr-headline kgr-headline--h3 kgr-headline--text kgr-headline--firstInText">
            {{ $t('Kostenstellen') }}
        </h3>
        <div
            class="kgr-alert kgr-alert--info kgr-row"
            v-html="$t('club.costCenters.infoText')"
        ></div>
        <div class="kgr-inputGroup kgr-inputGroup--constrainedWidth">
            <kgr-form-row
                :label="$t('Standard Kostenstelle')"
                :error="error"
                field-name="0"
            >
                <input
                    v-model.trim="defaultClubCostCenter.number"
                    type="text"
                    class="kgr-input kgr-inputGroup kgr-inputGroup--inline"
                    @input="emitChange"
                />
            </kgr-form-row>
            <div class="kgr-inputGroup__label">{{ $t('Abteilungskostenstellen') }}</div>
            <template v-for="(clubCostCenters, departmentId) in groupedClubCostCenters" :key="departmentId">
                <kgr-form-row
                    v-if="clubCostCenters && clubCostCenters.length > 0"
                    :error="error"
                    :field-name="'department' + departmentId.toString()"
                >
                    <div style="margin-bottom: 10px;">{{ clubCostCenters[0].departmentName }}</div>
                    <template v-for="(clubCostCenter, index) in clubCostCenters" :key="index">
                        <input
                            v-model.trim="clubCostCenter.number"
                            type="text"
                            class="kgr-input kgr-inputGroup"
                            @input="emitChange(); checkDefaultDepartment(departmentId, $event.target.value, clubCostCenter, clubCostCenters)"
                            :ref="index === clubCostCenters.length - 1 ? + departmentId.toString() : null"
                        />
                        <label
                            class="kgr-radio kgr-radio--inline"
                            style="position: absolute; right: -135px;"
                            :style="{top: (index === 0 ? 39 : index * 57 + 39) + 'px'}"
                        >
                            <input
                                type="radio"
                                :name="'dep_' + departmentId"
                                class="kgr-radio__control"
                                :checked="clubCostCenter.defaultForDepartment === true"
                                @click="setDefaultForDepartment(clubCostCenter, clubCostCenters)"
                            />
                            <span class="kgr-radio__label">{{ $t('Standard') }}</span>
                        </label>
                        <div
                            class="spacer"
                        ></div>
                    </template>
                    <div class="centered">
                        <button
                            class="kgr-button kgr-button--outline"
                            @click="addCostCenter(departmentId)"
                        >{{ $t('Kostenstelle hinzufügen') }}</button>
                    </div>
                </kgr-form-row>
            </template>
        </div>
    </div>
</template>

<script>
import ClubCostCenter from '../../../js/dto/ClubCostCenter.js'
import Error from '../../../js/model/Error.js';
import FormRow from '../../common/form/FormRow.vue';

export default {
    components: {
        'kgr-form-row': FormRow,
    },
    props: {
        clubCostCenters: {
            type: Array,
            required: true,
        },
        error: {
            type: Error,
            required: true,
        },
    },
    computed: {
        defaultClubCostCenter() {
            return this.clubCostCenters.filter(clubCostCenter => clubCostCenter.departmentId === null)[0];
        },
        groupedClubCostCenters() {
            let groupedClubCostCenters = [];
            this.clubCostCenters.forEach(clubCostCenter => {
                const key = clubCostCenter.departmentId;
                if (key === null) {
                    return;
                }
                if (!groupedClubCostCenters[key]) {
                    groupedClubCostCenters[key] = [];
                }
                groupedClubCostCenters[key].push(clubCostCenter);
            })
            return groupedClubCostCenters;
        },
    },
    methods: {
        addCostCenter(departmentId) {
            const clubCostCenter = new ClubCostCenter();
            clubCostCenter.departmentId = departmentId;
            this.groupedClubCostCenters[departmentId].push(clubCostCenter);
            this.$forceUpdate();
            this.$nextTick(() => {
                this.$refs[departmentId][0].focus();
            });
        },
        emitChange() {
            let clubCostCenters = [];
            clubCostCenters.push(this.defaultClubCostCenter);
            this.groupedClubCostCenters.forEach(groupedClubCostCenters => groupedClubCostCenters.forEach(item => clubCostCenters.push(item)));
            this.$emit('change', clubCostCenters);
        },
        setDefaultForDepartment(selectedClubCostCenter, clubCostCenters) {
            clubCostCenters.forEach(clubCostCenter => {
                clubCostCenter.defaultForDepartment = false;
            });
            selectedClubCostCenter.defaultForDepartment = true;
        },
        checkDefaultDepartment(departmentId, number, selectedClubCostCenter, clubCostCenters) {
            if (number.trim().length === 0 || this.groupedClubCostCenters[departmentId].length !== 1) {
                return;
            }
            this.setDefaultForDepartment(selectedClubCostCenter, clubCostCenters)
        },
    },
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">
div.spacer {
    margin-bottom: 10px;
}
div.centered {
    display: flex;
    flex-direction: column;
    align-items: center;
}
</style>
